import { Text, color } from "@smoothincorg/smooth-ui"
import React, { useCallback, useState } from "react"
import { BsPersonCircle } from "react-icons/bs"
import { MdMenu } from "react-icons/md"
import { Border } from "src/components/Border"
import { Logo } from "src/components/Logo"
import { Smoother } from "src/features/auth/hooks/useCurrentSmoother"
import {
  GOOGLE_OIDC_COOKIE_KEY,
  GOOGLE_OIDC_REFRESH_TOKEN_KEY,
  IS_NEXT,
} from "src/lib/constants/value"
import { boxShadow } from "src/lib/styles/variable"
import { useSidebarContext } from "src/store/SidebarContext"
import styled from "styled-components"

export const SIMPLE_HEADER_HEIGHT = 60

type Props = {
  currentSmoother: Smoother
  className?: string
  replace:
    | ReturnType<typeof import("next/navigation")["useRouter"]>["replace"]
    | ReturnType<typeof import("next/router")["useRouter"]>["replace"]
  pathname: string
}

const Component: React.FC<Props> = ({ pathname, replace, ...props }) => {
  const [open, setOpen] = useState(false)
  const { toggleSidebarVisibility } = useSidebarContext()

  const onSignOutClick = useCallback(async () => {
    sessionStorage.clear()
    document.cookie = `${GOOGLE_OIDC_COOKIE_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
    document.cookie = `${GOOGLE_OIDC_REFRESH_TOKEN_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`

    await fetch("/api/logout")

    replace(
      "/admin/sign-in?" +
        new URLSearchParams({
          "signed-out": "1",
          "redirect-to": pathname,
        })
    )
  }, [pathname, replace])

  return (
    <header
      className={`${props.className} smooth-ui-SimpleHeader`}
      style={{
        background: color.red,
        height: SIMPLE_HEADER_HEIGHT,
      }}
    >
      <div className={`${props.className}__content`}>
        <div className={`${props.className}__left`}>
          <button className={`${props.className}__menu-toggle`} onClick={toggleSidebarVisibility}>
            <MdMenu />
          </button>
          <Logo /><span
            style={{
              color: color.white,
              fontSize: "1.4rem",
              fontWeight: "bold",
            }}
          >
            for デモ
          </span>
        </div>
        <div className={`${props.className}__smoother`}>
          <button className={`${props.className}__toggle`} onClick={() => setOpen((d) => !d)}>
            <BsPersonCircle fill={color.white} />
          </button>
          {open && (
            <div className={`${props.className}__toggle-menu`}>
              <Text size={14} color="black">
                Logged in as：{props.currentSmoother?.name}
              </Text>
              <Border />
              <button onClick={onSignOutClick}>
                <Text size={14} color="black">
                  ログアウト
                </Text>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}

export const SimpleHeader = styled(Component)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;

  &__content {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
  }

  .smooth-ui-Logo {
    height: 24px;
    width: auto;
  }

  &__left {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  &__menu-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    color: ${color.white};
    padding: 4px;
    border-radius: 4px;
    transition: background-color 0.2s;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }

    > svg {
      width: 24px;
      height: 24px;
    }
  }

  &__smoother {
    position: relative;
  }

  &__toggle {
    height: 30px;
    display: flex;
    align-items: center;

    > svg {
      width: 30px;
      height: 100%;
    }
  }

  &__toggle-menu {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: absolute;
    top: 40px;
    right: 0;
    z-index: 101;
    background-color: #ffffff;
    ${boxShadow.normal};
    min-width: 200px;
    border-radius: 4px;

    .smooth-ui-Border {
      width: 100%;
    }

    > .smooth-ui-Text,
    > a,
    > button {
      text-align: left;
      width: 100%;
      padding: 10px;
    }

    > button {
      &:hover {
        background-color: ${color.lightGray};
      }
    }
  }
`
